it("should hide stack in details", function() {
	(function f() {
		require("./loader!");
	}).should.throw();
});



/*****************
 ** WEBPACK FOOTER
 ** ./compile/error-hide-stack/index.js
 ** module id = 0
 ** module chunks = 0
 **/